import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const user_key = 'user_sh'
const game_key = 'game_sh'
const role_key = 'role_sh'
const store = new Vuex.Store({
    state: {
        userInfo: {
            token: '',
            account: '',
            appId: 0
        },
        roleInfo: {
            sid: '0',
            rid: '0'
        },
        gameInfo: {
            appId: 10006,
            id: 502
        },
        games: [
            {
                id: 502,
                appId: 10006,
                name: '艾琳2',
                apple: {
                    clientId: "com.gtdsjd.sign", // This is the service ID we created.
                    redirectURI: "https://api.godsarrive.com/v1/web/official/apple/auth/10006?region=tw", // As registered along with our service ID
                },
                facebook: {
                    appId: '873099788807734'
                },
                google: {
                    clientId: '595236348197-funk8h6do551bqgjchstkk1aqd31co4b.apps.googleusercontent.com'
                },
                payments: [
                    {
                        id: 1,
                        name: 'MyCard',
                        payMethod: 'mycard',
                        key: 'mycard'
                    },
                    // {
                    //     id: 2,
                    //     name: 'Alipay HK',
                    //     payMethod: 'alipayplus--ALIPAY_HK',
                    //     key: 'alipay--alipayhk'
                    // },
                    // {
                    //     id: 3,
                    //     name: 'Boost',
                    //     payMethod: 'alipayplus--BOOST',
                    //     key: 'alipay--boost'
                    // },
                    // {
                    //     id: 4,
                    //     name: 'FPX',
                    //     payMethod: 'alipayplus--ONLINEBANKING_FPX',
                    //     key: 'alipay--fpx'
                    // },
                    // {
                    //     id: 5,
                    //     name: 'GrabPay MY',
                    //     payMethod: 'alipayplus--GRABPAY_MY',
                    //     key: 'alipay--grabpayMy'
                    // },
                    // {
                    //     id: 6,
                    //     name: 'GrabPay SG',
                    //     payMethod: 'alipayplus--GRABPAY_SG',
                    //     key: 'alipay--grabpaySg'
                    // },
                    // {
                    //     id: 7,
                    //     name: 'PAYNOW',
                    //     payMethod: 'alipayplus--PAYNOW',
                    //     key: 'alipay--paynow'
                    // },
                    // {
                    //     id: 8,
                    //     name: 'TNG',
                    //     payMethod: 'alipayplus--TNG',
                    //     key: 'alipay--touch'
                    // },
                    // {
                    //     id: 9,
                    //     name: 'IGameBUY HK',
                    //     payMethod: 'igamebuy--hk',
                    //     key: 'igamebuy--igamebuy'
                    // },
                    // {
                    //     id: 10,
                    //     name: 'IGameBUY TW',
                    //     payMethod: 'igamebuy--tw',
                    //     key: 'igamebuy--igamebuy'
                    // },
                    // {
                    //     id: 11,
                    //     name: 'IGameBUY MY',
                    //     payMethod: 'igamebuy--my',
                    //     key: 'igamebuy--igamebuy'
                    // },
                    // {
                    //     id: 12,
                    //     name: 'IGameBUY SG',
                    //     payMethod: 'igamebuy--sg',
                    //     key: 'igamebuy--igamebuy'
                    // },
                    // {
                    //     id: 13,
                    //     name: 'IGameBUY MO',
                    //     payMethod: 'igamebuy--mo',
                    //     key: 'igamebuy--igamebuy'
                    // },
                ]
            },
        ]
    },
    mutations: {
        initStore(state) {
            let a = JSON.parse(localStorage.getItem(user_key))
            console.log('init->', a)
            if (a) {
                console.log('init2->', a)
                this.commit('loginLocal', a)
            }
            let b = JSON.parse(localStorage.getItem(game_key))
            console.log('init->', b)
            if (b) {
                console.log('init2->', b)
                this.commit('setGameInfo', b)
            } else {
                this.commit('setGameInfo', state.games[0])
            }
            let c = JSON.parse(localStorage.getItem(role_key))
            console.log('role->', c)
            if (c) {
                console.log('init2->', c)
                this.commit('loginRole', c)
            }
        },
        loginLocal(state, payload) {
            console.log('loginLocal->', payload)
            state.userInfo = Object.assign(state.userInfo, payload)
            console.log("test", state.userInfo)
            localStorage.setItem(user_key, JSON.stringify(state.userInfo));
        },
        setGameInfo(state, payload) {
            state.gameInfo = payload //Object.assign(state.gameInfo, payload)
            localStorage.setItem(game_key, JSON.stringify(state.gameInfo));
        },
        loginRole(state, payload) {
            state.roleInfo = Object.assign(state.roleInfo, payload)
            localStorage.setItem(role_key, JSON.stringify(state.roleInfo));
        },
        logout(state) {
            state.userInfo = {
                token: '',
                account: '',
                appId: 0
            }
            localStorage.setItem(user_key, '{}');
            state.roleInfo = {
                sid: '0',
                rid: '0'
            }
            localStorage.setItem(role_key, '{}');
        }
    }
})
export default store